import { rolePriorities } from 'src/utils/properties.utils';

export const getHighestPriorityRole = (roles: string[]): string => {
  return roles.reduce((highest, role) => {
    if (
      rolePriorities[role as keyof typeof rolePriorities] <
      rolePriorities[highest as keyof typeof rolePriorities]
    ) {
      return role;
    }
    return highest;
  });
};
